import { Icon, useTheme } from '@web-chat-core/ui-kit';
import { useTranslation } from 'react-i18next';
import { FEATURES } from 'consts';
import { ModalName } from 'features/Modals';
import { useModal } from 'useCase/modal/useModal';
import { ControlButton } from 'ui/components';
import { isFeatureOn } from 'useCase/featureFlags/featureFlagsApi';

export const VirtualBackgroundButton = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { toggleModal } = useModal();
    const isVirtualBackgroundsEnabled = isFeatureOn(FEATURES.VCS_VIRTUAL_BACKGROUNDS_ENABLED);

    const handleClick = () => {
        toggleModal(ModalName.VIRTUAL_BACKGROUND);
    };

    if (!isVirtualBackgroundsEnabled) {
        return null;
    }

    return (
        <ControlButton title={t('videoconference_virtual_backgrounds')} onClick={handleClick}>
            <Icon icon="icAddFacePhoto" color={theme.root.colors.basicColors['90%']} size={24} />
        </ControlButton>
    );
};
